import LocationManagerBooking from './LocationManagerBooking.container';

export default LocationManagerBooking;
